import { detach, isNullOrUndefined } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import { RenderType } from '../base/enum';
import { CLS_COUNT, CLS_WARNING, CLS_ERROR } from '../base/classes';
/**
 * `Count` module is used to handle Count actions.
 */
var Count = /** @class */ (function () {
    function Count(parent, serviceLocator) {
        this.parent = parent;
        this.locator = serviceLocator;
        this.renderFactory = this.locator.getService('rendererFactory');
        this.addEventListener();
    }
    Count.prototype.initializeInstance = function () {
        this.contentRenderer = this.renderFactory.getRenderer(RenderType.Content);
        this.editPanel = this.contentRenderer.getEditPanel();
        this.addEventListener();
    };
    /**
     * renderCount method
     * @hidden
     * @deprecated
     */
    Count.prototype.renderCount = function () {
        this.initializeInstance();
        this.element = this.parent.createElement('span', { className: CLS_COUNT });
        this.contentRenderer.getPanel().parentElement.appendChild(this.element);
        this.appendCount();
        if (this.parent.maxLength !== -1) {
            this.charCountBackground(this.htmlLength);
        }
    };
    Count.prototype.appendCount = function () {
        var htmlText = this.parent.editorMode === 'Markdown' ? this.editPanel.value.trim() :
            this.editPanel.textContent.trim();
        this.htmlLength = htmlText.length;
        var string = this.parent.maxLength === -1 ? this.htmlLength : this.htmlLength + ' / ' + this.parent.maxLength;
        this.element.innerHTML = string;
    };
    Count.prototype.charCountBackground = function (htmlLength) {
        var percentage = (htmlLength / this.parent.maxLength) * 100;
        if (percentage < 85) {
            this.element.classList.remove(CLS_WARNING);
            this.element.classList.remove(CLS_ERROR);
        }
        else if (percentage > 85 && percentage <= 90) {
            this.element.classList.remove(CLS_ERROR);
            this.element.classList.add(CLS_WARNING);
        }
        else if (percentage > 90) {
            this.element.classList.remove(CLS_WARNING);
            this.element.classList.add(CLS_ERROR);
        }
    };
    /**
     * @hidden
     * @deprecated
     */
    Count.prototype.refresh = function () {
        if (!isNullOrUndefined(this.editPanel)) {
            this.appendCount();
            if (this.parent.maxLength !== -1) {
                this.charCountBackground(this.htmlLength);
            }
        }
    };
    /**
     * Destroys the Count.
     * @method destroy
     * @return {void}
     * @hidden
     * @deprecated
     */
    Count.prototype.destroy = function () {
        if (this.element && !isNullOrUndefined(this.parent.element.querySelector('.' + CLS_COUNT))) {
            detach(this.element);
        }
        this.removeEventListener();
    };
    Count.prototype.toggle = function (e) {
        this.element.style.display = (e.member === 'viewSource') ? 'none' : 'block';
    };
    Count.prototype.addEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.initialEnd, this.renderCount, this);
        this.parent.on(events.keyUp, this.refresh, this);
        this.parent.on(events.count, this.refresh, this);
        this.parent.on(events.refreshBegin, this.refresh, this);
        this.parent.on(events.mouseDown, this.refresh, this);
        this.parent.on(events.destroy, this.destroy, this);
        this.parent.on(events.sourceCode, this.toggle, this);
        this.parent.on(events.updateSource, this.toggle, this);
    };
    Count.prototype.removeEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.initialEnd, this.renderCount);
        this.parent.off(events.keyUp, this.refresh);
        this.parent.off(events.refreshBegin, this.refresh);
        this.parent.off(events.count, this.refresh);
        this.parent.off(events.mouseDown, this.refresh);
        this.parent.off(events.destroy, this.destroy);
        this.parent.off(events.sourceCode, this.toggle);
        this.parent.off(events.updateSource, this.toggle);
    };
    /**
     * For internal use only - Get the module name.
     */
    Count.prototype.getModuleName = function () {
        return 'count';
    };
    return Count;
}());
export { Count };
